<template>
  <div class="dialogues">
    <div class="condition">
      <div class="title" style="padding-bottom:16px;margin-bottom:24px;height:40px;border-bottom:1px solid rgba(240, 240, 240, 1)">
        <span style="color:rgba(51, 51, 51, 1)" class="left">对话记录</span>
        <a-icon class="right" @click="ifDisplay" v-if='ifShow' type="up" />
        <a-icon class="right" @click="ifDisplay" v-if='!ifShow' type="down" />
      </div>
      <div style="clear:both"></div>
      <div v-if='ifShow'>
        <a-row>
          <a-col :span="6">
            <div class="title" style="margin-bottom:8px;color:rgba(80, 80, 80, 1);font-size:14px;">交互日期：</div>
            <a-range-picker
            style="min-width:319px;width:100%;max-width:340px;"
              :locale="locale"
              @change="onChange"
              :placeholder="defaultTime"
              :showTime="{
                hideDisabledOptions: true,
                defaultValue: [moment('00:00:00', 'HH:mm:ss'), moment('23:59:59', 'HH:mm:ss')],
              }"
              format="YYYY-MM-DD HH:mm:ss"
            />
          </a-col>
          <a-col :span="6">
            <div style="margin-bottom:8px;color:rgba(80, 80, 80, 1);font-size:14px;">电话号码：</div>
            <a-input class="phone" style="min-width:195px;width:100%;max-width:220px;" v-model="phone" placeholder="请输入需要查询的电话号码" />
          </a-col>
          <a-col :span="6">
            <div style="margin-bottom:8px;color:rgba(80, 80, 80, 1);font-size:14px;">项目来源：</div>
            <a-select style="min-width:270px;width:100%;max-width:280px;"
              @change="handleSelectChange"
              :defaultValue="defaultSelectProName"
              :key="defaultSelectProName"
              v-model="defaultProId"
            >
              <a-select-option :title="item.name" :value="item.id" v-for="(item, index) in proList5" :key="index">
                {{item.name}}
              </a-select-option>
            </a-select>
          </a-col>
          <a-col :span="6">
            <div style="margin-bottom:8px;color:rgba(80, 80, 80, 1);font-size:14px;">项目标签：</div>
            <a-select style="width: 80%" 
              placeholder='请选择'
              @change="handleChange"  
              mode="multiple"
              v-model="defaultTagsSelect"
            >
              <a-select-option :title="item.name" v-for="(item, index) in labelsTags" :key="index" :value="item.id">{{item.name}}</a-select-option>
            </a-select>
          </a-col>
         
        </a-row>
        <a-row style="margin-top:16px;">
          <a-col :span="18">
            <div style="margin-bottom:8px;color:rgba(80, 80, 80, 1);font-size:14px;">通话时长：</div>
            <span style="color:rgba(80, 80, 80, 1);font-size:14px;">大于</span>
            <a-input class="phone" style="width:80px;margin:0 8px;" v-model="inputTimeBigThan" placeholder="请输入"/>
            <span style="color:rgba(80, 80, 80, 1);font-size:14px;">秒；</span>
            <span style="margin-left:7px;color:rgba(80, 80, 80, 1);font-size:14px;">小于</span>
            <a-input class="phone" style="width:80px;margin:0 8px;" v-model="inputTimeLessThan" placeholder="请输入"/>
            <span style="color:rgba(80, 80, 80, 1);font-size:14px;">秒；</span>
          </a-col>
          <a-col :span="6" style="padding-top:29px;">
            <a-button @click="reset" style="margin-right:13px;border:1px solid rgba(34, 215, 187, 1);color:rgba(34, 215, 187, 1);width:80px;text-align:center">重置</a-button>
            <a-button type="primary" @click="initQueryData()" style="border:1px solid rgba(34, 215, 187, 1);background:rgba(34, 215, 187, 1);width:80px;text-align:center">查询</a-button>
          </a-col>
        </a-row>
      </div>
    
    </div>
    <div class="result-view1">
      <div class="operation">
        <div class="left" style="display:inline-block">
          <span style="color:rgba(51, 51, 51, 1);font-size:16px;">查询结果：</span>
          <span style="color:rgba(34, 215, 187, 1)">{{total5}}</span>
        </div>
        <div class="right">
          <a-button type="primary" style="margin-right:8px;background:rgba(34, 215, 187, 1);border:1px solid rgba(34, 215, 187, 1)" @click="queryData('dialogues')">按对话导出</a-button>
          <a-button type="primary" style="margin-right:8px;border:1px solid rgba(34, 215, 187, 1);background:rgba(34, 215, 187, 1)" @click="queryData('node')">按节点导出</a-button>
          <a-button type="primary" style="margin-right:8px;border:1px solid rgba(34, 215, 187, 1);background:rgba(34, 215, 187, 1)" @click="queryData('tag')">按标签导出</a-button>
        </div>
      </div>
      <div style="clear:both"></div>
      <div class="table-content">
        <a-table :data-source="data5" :pagination='false' :loading="ifShowLoading" :rowKey="record => record.id">
          <a-table-column key="phone" title="号码" data-index="phone">
            <template slot-scope="text, record">
              <div>
                <router-link target="_blank" rel="opener" :to="{path:'/SimulatedDialogue',query:{source:'dialogues',roomId:record.roomId,id:record.id}}">
                  <span style="color:rgba(34, 215, 187, 1)">{{ record.phone }}</span>
                </router-link>
              </div>
            </template>
          </a-table-column>
          <a-table-column key="time" title="时间" data-index="time" />
          <a-table-column key="duration" title="时长" data-index="duration">
            <template slot-scope="text, record">
              <div>
                <span>{{ (record.duration/1000).toFixed(0) }}</span>
              </div>
            </template>
          </a-table-column>
          <a-table-column key="nodeCount" title="节点数量" data-index="nodeCount" />
          <a-table-column key="project" title="所属项目" data-index="project" />
          <a-table-column key="channelCode" title="通道注册号码" data-index="channelCode" />
          <a-table-column key="transferNo" title="转接号码" data-index="transferNo" />
          <a-table-column key="transferTime" title="转接时间" data-index="transferTime" />
          <!-- <a-table-column key="transferDuration" title="转接时长" data-index="transferDuration" /> -->
          <a-table-column key="transferDuration" title="转接时长" data-index="transferDuration">
            <template slot-scope="text, record">
              <div>
                <span>{{ (record.transferDuration/1000).toFixed(0) }}</span>
              </div>
            </template>
          </a-table-column>
        </a-table>
        <div @click="lookOutputDegress" style="float:left;display:inline-block;width:88px;height:32px;background:rgba(34, 215, 187, 1);margin-top:16px;line-height:32px;text-align:center;border-radius:4px;position:relative;cursor:pointer;" >
          <span style="color:#fff;font-size:14px;">导出进度</span>
          <span v-if="unreadNum!=0" style="position:absolute;width:18px;height:18px;display:inline-block;border-radius:9px;color:#fff;font-size:11px;background:rgba(245, 87, 78, 1);line-height:18px;text-align:center;right:-7px;top:-8px;">{{unreadNum}}</span>
        </div>
        <a-pagination
          style="float:right;margin-top:16px"
          v-model="currentPage5"
          :page-size-options="pageSizeOptions5"
          :total="total5"
          show-size-changer
          :page-size="pageSize5"
          @showSizeChange="onShowSizeChange"
          @change="onChangeSample"
        >
          <template slot="buildOptionText" slot-scope="props">
            <span>{{ props.value }}条/页</span>
          </template>
        </a-pagination>
      </div>
    </div>
    <!-- <router-link target="_blank" rel="opener" to="/Communication" class="dialogBox">
      <a-icon style="z-index:1000;font-size:25px" type="message" />
    </router-link> -->
    <a-modal v-model="outputProgress" title="导出进度详情" footer='' width='1160px'>
      <div >
        <a-row>
          <a-col :span="8">
            <div style="color:rgba(80, 80, 80, 1);font-size:14px;">任务类型：</div>
            <div style="margin-top:6px;">
              <a-select style="width:300px;color:rgba(204, 204, 204, 1)" key='0' defaultValue='' @change="changeType">
                <a-select-option key='1' value=''>
                  请选择
                </a-select-option>
                <a-select-option key='2' value='CALL_RECORD_DIALOGUE'>
                  按对话
                </a-select-option>
                <a-select-option key='3' value='CALL_RECORD_NODE'>
                  按节点
                </a-select-option>
                <a-select-option key='4' value='CALL_RECORD_LABEL'>
                  按标签
                </a-select-option>
              </a-select>
            </div>
          </a-col>
          <a-col :span="8">
            <div style="color:rgba(80, 80, 80, 1);font-size:14px;">任务状态：</div>
            <div style="margin-top:6px;">
              <a-select style="width:300px;color:rgba(204, 204, 204, 1)" key='0' defaultValue='' @change="changeStatus">
                <a-select-option key='1' value=''>
                  请选择
                </a-select-option>
                <a-select-option key='2' value='TODO'>
                  待执行
                </a-select-option>
                <a-select-option key='3' value='DOING'>
                  执行中
                </a-select-option>
                <a-select-option key='4' value='DONE'>
                  已完成
                </a-select-option>
                <a-select-option key='5' value='FAIL'>
                  导出失败
                </a-select-option>
              </a-select>
            </div>
          </a-col>
          <a-col :span="8">
            <div style="color:rgba(80, 80, 80, 1);font-size:14px;">创建时间：</div>
            <div style="margin-top:6px;color:rgba(204, 204, 204, 1)">
              <a-range-picker
                @change="changeDate"
                :locale="locale"
                :showTime="{
                  hideDisabledOptions: true,
                  defaultValue: [moment('00:00:00', 'HH:mm:ss'), moment('23:59:59', 'HH:mm:ss')],
                }"
                format="YYYY-MM-DD HH:mm:ss"
              />
            </div>
          </a-col>
        </a-row>
        <div class="output-detail">
          <a-table style="margin-top:24px;" :data-source="outputData.records" :pagination='false' :loading="outputListPro.ifLoading" :rowKey="record => record.id">
            <a-table-column key="createTime" title="创建时间" data-index="createTime" />
            <a-table-column key="type" title="任务类型" data-index="type" >
              <template slot-scope="text, record">
                <div>
                  <div v-if="record.type=='CALL_RECORD_DIALOGUE'">按对话</div>
                  <div v-if="record.type=='CALL_RECORD_NODE'">按节点</div>
                  <div v-if="record.type=='CALL_RECORD_LABEL'">按标签</div>
                </div>
              </template>
            </a-table-column>
            <a-table-column key="projectName" title="项目名称" data-index="projectName" />
            <a-table-column key="dataCount" title="数据总量" data-index="dataCount" />
            <a-table-column key="status" title="状态" data-index="status">
              <template slot-scope="text, record">
                <div>
                  <div v-if="record.status=='TODO'">待执行</div>
                  <div v-if="record.status=='DOING'">执行中</div>
                  <div v-if="record.status=='DONE'">已完成</div>
                  <div v-if="record.status=='FAIL'">导出失败</div>
                </div>
              </template>
            </a-table-column>
            <a-table-column key="duration" title="耗时(秒)" data-index="duration" />
            <a-table-column key="download_url" title="操作" data-index="download_url">
              <template slot-scope="text, record">
                <div>
                  <span v-if="record.status!='DONE'">下载</span>
                  <div v-if="record.status=='DONE'">
                    <a :href="record.download_url">
                      <span style="color:rgba(34, 215, 187, 1);cursor:pointer">下载</span>
                    </a>
                  </div>
                </div>
              </template>
            </a-table-column>
          </a-table>
          <a-pagination
            style="float:right;margin-top:16px"
            v-model="outputListPro.current"
            :page-size-options="outputListPro.size"
            :total="outputData.total"
            show-size-changer
            :page-size="outputListPro.pageSize"
            @showSizeChange="proSizeChange"
            @change="proChangeSample"
          >
            <template slot="buildOptionText" slot-scope="props">
              <span>{{ props.value }}条/页</span>
            </template>
          </a-pagination>
        </div>
      
        <div style="clear:both"></div>
      </div>
    </a-modal>
  </div>
</template>

<script>
import locale from 'ant-design-vue/es/date-picker/locale/zh_CN';
import moment from 'moment';
export default {
  name: 'Dialogues',
  props: {
    msg: String
  },
  data() {
    return {
      locale,
      ifShow:true,
      proList5: [],
      startTime5: '',
      endTime5: '',
      dateString: [],
      phone: '',
      projectId: '',
      labelsTags: [],
      currentPage5: 1,
      data5: [],
      total5: 0,
      labelsString: '',
      defaultSelectProId: '',
      defaultSelectProName: '请选择',
      defaultTime: [],
      defaultTagsSelect: undefined,
      defaultProId: '请选择',
      ifShowLoading: false,
      pageSize5: 10,
      pageSizeOptions5: ['10', '20', '50', '100'],
      outputProgress: false,
      unreadNum: 0,
      outputData: {},
      outputListPro: {
        current: 1,
        size: ['10', '20', '50', '100'],
        type: '',
        pageSize: 10,
        status: '',
        startDate: '',
        endDate: '',
        ifLoading: false,
      },
      inputTimeBigThan: '',
      inputTimeLessThan: ''
    }
  },
  methods: {
    moment,
    changeType(value) {
      this.outputListPro.type = value
      this.lookOutputDegress()
    },
    changeStatus(value) {
      this.outputListPro.status = value
      this.lookOutputDegress()
    },
    changeDate(date, dateString) {
      console.log(date)
      this.outputListPro.startDate = dateString[0]
      this.outputListPro.endDate = dateString[1]
      this.lookOutputDegress()
    },
    proSizeChange(current, pageSize) {
      this.outputListPro.current = current
      this.outputListPro.pageSize = pageSize;
      this.lookOutputDegress()
    },
    proChangeSample(value) {
      this.outputListPro.current = value
      this.lookOutputDegress()
    },
    queryUnreadNum() {
      this.axios(
        {
          method:'get',
          url:'/api/exportRecord/unreadCount', 
      })
      .then(response=> {
        if(response.data.code == 0){
          this.unreadNum = response.data.data.count
        }else{
          this.$message.error(response.data.message);
        }
      })
      .catch(error=> {
        console.log(error)
      })
    },
    lookOutputDegress() {
      this.outputProgress = true
      this.outputListPro.ifLoading = true
      this.axios(
        {
          method:'get',
          url:'/api/exportRecord/list', 
          params:{
            current: this.outputListPro.current,
            size: this.outputListPro.pageSize,
            type: this.outputListPro.type,
            status: this.outputListPro.status,
            startDate: this.outputListPro.startDate,
            endDate: this.outputListPro.endDate,
          }
      })
      .then(response=> {
        this.outputListPro.ifLoading = false
        if(response.data.code == 0){
          this.outputData = response.data.data
          this.queryUnreadNum()
        }else{
          this.$message.error(response.data.message);
        }
      })
      .catch(error=> {
        this.outputListPro.ifLoading = false
        console.log(error)
      })
    },
    range(start, end) {
      const result = [];
      for (let i = start; i < end; i++) {
        result.push(i);
      }
      return result;
    },
    ifDisplay(){
      this.ifShow = !this.ifShow
    },
    getCurrentStyle(current) {
      const style = {};
      if (current.date() === 1) {
        style.border = '1px solid #1890ff';
        style.borderRadius = '50%';
      }
      return style;
    },
    handleSelectChange(value) {
      this.labelsString = ''
      this.projectId = value
      this.defaultTagsSelect = []
      for(let i = 0; i < this.proList5.length; i++){
        if(this.proList5[i]['id'] == value){
          this.labelsTags = this.proList5[i].labelList
        }
      }
    },
    handleChange(value) {
      this.labelsString = ''
      for(let i = 0; i < value.length; i++){
        this.labelsString += value[i] + ','
      }
      if(this.labelsString != ""){
        this.labelsString = this.labelsString.substring(0,this.labelsString.length-1);
      }
    },
    onShowSizeChange(current, pageSize) {
      this.currentPage5 = current
      this.pageSize5 = pageSize;
      this.queryData()
    },
    initQueryData() {
      this.currentPage5 = 1
      this.pageSize5 = 10;
      this.queryData()
    },
    queryData(value) {
      this.ifShowLoading = true
      this.axios(
        {
          method:'get',
          url:'/api/callRecord/list', 
          params:{
            current: this.currentPage5,
            size: this.pageSize5,
            phone: this.phone,
            startTime: this.startTime5,
            endTime: this.endTime5,
            projectId: this.projectId,
            labels: this.labelsString,
            gtDuration: this.inputTimeBigThan!=''?this.inputTimeBigThan*1000:this.inputTimeBigThan,
            ltDuration: this.inputTimeLessThan!=''?this.inputTimeLessThan*1000:this.inputTimeLessThan,
          }
      })
      .then(response=> {
        this.ifShowLoading = false
        if(response.data.code == 0){
          this.data5 = response.data.data.records
          this.total5 = response.data.data.total
          if(value == 'dialogues'){
            this.exportFileDialogues()
          }else if(value == 'node'){
            this.exportFileNode()
          }else if(value == 'tag'){
            this.exportFileTag()
          }
        }else{
          this.$message.error(response.data.message);
        }
      })
      .catch(error=> {
        this.ifShowLoading = false
        console.log(error)
      })
    },
    onChange(date, dateString) {
      this.startTime5 = dateString[0]
      this.endTime5 = dateString[1]
    },
    onChangeSample(value) {
      this.currentPage5 = value
      this.queryData()
    },
    confirm(type) {
      let title = ''
      if(type == 'dialogues'){
        title = '本次导出预计'+(Number(Math.floor(this.total5/4000))+6)+'分钟完成，确定按对话导出？'
      }else if(type == "node"){
        title = '本次导出预计'+(Number(Math.floor(this.total5/4000))+6)+'分钟完成，确定按节点导出？'
      }else if(type == "tag"){
        title = '本次导出预计'+(Number(Math.floor(this.total5/4000))+6)+'分钟完成，确定按标签导出？'
      }
      this.$confirm({
        title: '提示',
        content: title,
        okText: '确认',
        cancelText: '取消',
        icon: 'warning',
        onOk: ()=> {
          if(type == "dialogues"){
            this.outputFileDialogues()
          }else if(type == "node"){
            this.outputFileNode()
          }else if(type == "tag"){
            this.outputFileTag()
          }
        },
      })
    },
    outputFileDialogues() {
      this.axios(
        {
          method:'get',
          url:'/api/callRecord/list/export1', 
          params:{
            phone: this.phone,
            startTime: this.startTime5,
            endTime: this.endTime5,
            projectId: this.projectId,
            labels: this.labelsString,
            gtDuration: this.inputTimeBigThan!=''?this.inputTimeBigThan*1000:this.inputTimeBigThan,
            ltDuration: this.inputTimeLessThan!=''?this.inputTimeLessThan*1000:this.inputTimeLessThan,
          } 
        }
      )
      .then(response=> {
        if(response.data.code == 0){
          this.$message.success('导出成功，请查看导出进度！')
          this.queryUnreadNum()
        }else{
          this.$message.error(response.data.message)
        }
      })
      .catch(error=> {
        console.log(error)
      })
    },
    exportFileDialogues() {
      if(this.projectId == ''){
       this.$message.error('请先选择来源');
      }else if(this.total5 > 50000){
        this.$message.error('数据量过大，无法导出');
      }else if(this.total5 == 0){
        this.$message.error('该状态下暂无数据，无需导出')
      }else{
        this.confirm('dialogues')
      }
    },
    outputFileNode() {
      this.axios(
        {
          method:'get',
          url:'/api/callRecord/list/export2', 
          params:{
            phone: this.phone,
            startTime: this.startTime5,
            endTime: this.endTime5,
            projectId: this.projectId,
            labels: this.labelsString,
            gtDuration: this.inputTimeBigThan!=''?this.inputTimeBigThan*1000:this.inputTimeBigThan,
            ltDuration: this.inputTimeLessThan!=''?this.inputTimeLessThan*1000:this.inputTimeLessThan,
          } 
        }
      )
      .then(response=> {
        if(response.data.code == 0){
          this.$message.success('导出成功，请查看导出进度！')
          this.queryUnreadNum()
        }else{
          this.$message.error(response.data.message)
        }
      })
      .catch(error=> {
        console.log(error)
      })
    },
    exportFileNode() {
      if(this.projectId == ''){
        this.$message.error('请先选择来源');
      }else if(this.total5 > 50000){
        this.$message.error('数据量过大，无法导出');
      }else if(this.total5 == 0){
        this.$message.error('该状态下暂无数据，无需导出')
      }else{
        this.confirm('node')
      }
    },
    exportFileTag() {
      if(this.projectId == ''){
       this.$message.error('请先选择来源');
      }else if(this.total5 > 50000){
        this.$message.error('数据量过大，无法导出');
      }else if(this.total5 == 0){
        this.$message.error('该状态下暂无数据，无需导出')
      }else{
        this.confirm('tag')
      }
    },
    outputFileTag() {
      this.axios(
        {
          method:'get',
          url:'/api/callRecord/list/export3', 
          params:{
            phone: this.phone,
            startTime: this.startTime5,
            endTime: this.endTime5,
            projectId: this.projectId,
            labels: this.labelsString,
            gtDuration: this.inputTimeBigThan!=''?this.inputTimeBigThan*1000:this.inputTimeBigThan,
            ltDuration: this.inputTimeLessThan!=''?this.inputTimeLessThan*1000:this.inputTimeLessThan,
          } 
        }
      )
      .then(response=> {
        if(response.data.code == 0){
          this.$message.success('导出成功，请查看导出进度！')
          this.queryUnreadNum()
        }else{
          this.$message.error(response.data.message)
        }
      })
      .catch(error=> {
        console.log(error)
      })
    },
    download(data) {
      if (!data) {
          return
      }
      const url = window.URL.createObjectURL(new Blob([data]))
      let link = document.createElement('a')
      link.style.display = 'none'
      link.href = url
      link.setAttribute('download', '对话记录.csv')
      document.body.appendChild(link)
      link.click()
      URL.revokeObjectURL(link.href) // 释放URL 对象
      document.body.removeChild(link)
      link = null
    },
    reset() {
      this.phone = '',
      this.projectId = '',
      this.labelsTags = [],
      this.currentPage5 = 1,
      this.data5 = [],
      this.total5 = 0,
      this.labelsString = '',
      this.defaultProId = '请选择'
      this.defaultTagsSelect = []
    },
    queryProjectWithLabel(){
      this.axios.get('/api/dropdown/projectWithLabel')
      .then(response=> {
        if(response.data.code == 0){
          this.proList5 = response.data.data
          if(this.$route.query.projectId != undefined){
            this.projectId = this.$route.query.projectId
            this.defaultSelectProId = this.$route.query.projectId
            for(let i = 0; i < this.proList5.length; i++){
              if(this.proList5[i]['id'] == this.$route.query.projectId){
                this.defaultSelectProName = this.proList5[i]['name']
              }
            }
          }
        }else{
          this.$message.error(response.data.message);
        }
      })
      .catch(error=> {
        console.log(error)
      })
    },
    getCurrentDate(format) {
      var now = new Date();
      var year = now.getFullYear(); //得到年份
      var month = now.getMonth();//得到月份
      var date = now.getDate();//得到日期
      var hour = now.getHours();//得到小时
      var minu = now.getMinutes();//得到分钟
      var sec = now.getSeconds();//得到秒
      month = month + 1;
      if (month < 10) month = "0" + month;
      if (date < 10) date = "0" + date;
      if (hour < 10) hour = "0" + hour;
      if (minu < 10) minu = "0" + minu;
      if (sec < 10) sec = "0" + sec;
      var time = "";
      //开始时间
      if(format==1){
        time = year + "-" + month + "-" + date + " " + "00:00:00";
      }
      //结束时间
      else if(format==2){
        time = year + "-" + month + "-" + date+ " " + 23 + ":" + 59 + ":" + 59;
      }
      return time;
    }
  },
  mounted: function() {
    this.sessionData('set','currentNavItem','Dialogues');
    if(this.$route.query.projectId != undefined){
      this.defaultProId = Number(this.$route.query.projectId)
    }
    this.startTime5 = this.getCurrentDate(1)
    this.endTime5 = this.getCurrentDate(2)
    this.defaultTime.push(this.startTime5)
    this.defaultTime.push(this.endTime5)
    this.queryProjectWithLabel()
    this.queryUnreadNum()
  }
}
</script>

<style lang="less" scoped>
  .dialogues{
    padding: 24px 24px 50px;
    .left{
      float: left;
    }
    .right{
      float: right;
    }
    height: 100%;
    background: #eee;
    display: flex;
    flex-direction: column;
    overflow-y: auto;
    // padding-bottom: 50px;
    .condition{
      // border-radius: 4px;
      width: 100%;
      max-height: 337px;
      background: #fff;
      padding: 24px 40px;
      .title{
        // padding-bottom: 8px;
        span{
          font-size: 18px;
          color: #333;
        }
        i{
          cursor: pointer;
          // display: none;
        }
        i:hover{
          color: rgba(34, 215, 187, 1);
        }
      }
      .date{
        span.title{
          color: rgba(80, 80, 80, 1);
          font-size: 14px;
          display: inline-block;
        }
      }
      .info{
        span{
          margin-right: 8px;
        }
        .phone{
          width: 40%;
        }
      }
      .pro-tag{
        span{
          margin-right: 8px;
        }
      }
      .btn-group{
        button:nth-child(1):hover{
          color: rgba(34, 215, 187, 1) !important;
        }
        button span{
          margin-right: 0px !important;
        }
      }
    }
    .condition:hover{
      i{
        display: inline-block;
      }
    }
    .result-view1{
      margin-top: 16px;
      // border-radius: 4px;
      flex: 1;
      background: #fff;
      padding: 22px 40px;
      .operation{
        font-size: 14px;
        color: rgba(204, 204, 204, 1);
      }
      .table-content{
        padding-top: 15px;
        position: relative;
        th{
          height: 48px;
          line-height: 48px;
          background: #F0F0F0;
          padding-top:0px;
          padding-bottom:0px;
        }
        td{
          padding-top: 8px;
          padding-bottom: 8px;
        }
      }
    }
  }
  .output-detail{
    .ant-table-thead > tr > th{
      height: 48px;
      line-height: 48px;
      background: #F0F0F0 !important;
      padding-top:0px;
      padding-bottom:0px;
    }
    td{
      padding-top: 8px;
      padding-bottom: 8px;
    }
  }
</style>
